import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BaccaratOutcome, CardPosition } from '../models/communication/baccarat-enums.model';
import { Card } from '../models/communication/cards.enum';

@Component({
    selector: 'app-baccarat-table',
    standalone: true,
    imports: [CommonModule, RouterOutlet],
    templateUrl: './baccarat-table.component.html',
    styleUrl: './baccarat-table.component.scss'
})
export class BaccaratTableComponent {
    @Input()
    cards?: Partial<Record<CardPosition, Card>>;

    @Input()
    bankerHandValue?: number;

    @Input()
    playerHandValue?: number;

    @Input()
    nextCardPosition?: CardPosition;

    @Input()
    outcome?: BaccaratOutcome;

    protected readonly CardPosition = CardPosition;
    protected readonly BaccaratOutcome = BaccaratOutcome;
}
